{
  "collapse": "Ahenda",
  "expand": "Laienda"
}
